import { MemoizedSelector, createSelector } from '@ngrx/store';
import { OpeningSchedule } from '../../../../../core/model';
import { CheckoutState, StateWithCheckout } from '../checkout-state';
import { getCheckoutState } from './feature.selector';

export const getHolidays: MemoizedSelector<StateWithCheckout, OpeningSchedule | undefined> = createSelector(
  getCheckoutState,
  (state: CheckoutState) => state.holidays || undefined
);
